module.exports = __webpack_public_path__ + "static/converge-480x480-1d87d85809ef2a1520502cdbaf0324ce.png";